import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-companies-companies-dashboard',
    templateUrl: './companies-companies-dashboard.component.html',
    styleUrls: ['./companies-companies-dashboard.component.scss'],
    standalone: false
})
export class CompaniesCompaniesDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
